<template>
  <!-- 潜在客户详情 -->
  <div class="custom-detail">
    <!-- 详情抽屉 :wrapperClosable="false"-->
    <div style="background:#F5F7FA">
      <el-button size="mini" type="primary" @click="drawerClose" class="closeButton">
        收起
        <i class="el-icon-download" style="transform: rotate(-90deg);"></i>
      </el-button>
      <!-- 公司简介 -->
      <div class="custom-company-profile">
        <!-- 第一行 -->
        <div class="custom-pro-one">
          <div style="display:flex;">
            <!-- 公司名称 -->
            <div class="custom-one-title" :style="isList ? '' : 'marginRight: 12px'">
              <el-tooltip
                class="item"
                effect="light"
                :disabled="isShowTooltip"
                :content="detailData.companyName"
                placement="bottom-start"
              >
                <p @mouseover="onMouseOver('customNameStrTootip')">
                  <span class="text" ref="customNameStrTootip">{{detailData.companyName}}</span>
                </p>
              </el-tooltip>
            </div>

            <!-- 切换公司按钮 -->
            <div v-if="isList" style="margin: 0 12px; position: relative; top: 3px;">
              <el-button-group style="display:flex;">
                <el-button
                  :disabled="switchData.index <= 0 || backMsg==true"
                  icon="el-icon-arrow-left"
                  style="width:18px; height:18px; padding:0;margin-right:4px;"
                  @click="preCompany"
                ></el-button>
                <el-button
                  :disabled="switchData.ids && (switchData.ids.length -1 <= switchData.index) || backMsg==true"
                  icon="el-icon-arrow-right"
                  style="width:18px; height:18px; padding:0;"
                  @click="nextCompany"
                ></el-button>
              </el-button-group>
            </div>
            <!-- 特别关注按钮 -->
            <div @click="focusCustomer">
              <div
                style="font-size:17px; position: relative; top: 3px; color: #ff7f2a;"
                class="iconfont icon-icon-shoucang1"
                v-if="detailData.attentionStatus == 20"
              ></div>
              <div
                style="font-size:17px; position: relative; top: 3px; color:#98A3B7; "
                class="iconfont icon-icon-shoucang1"
                v-else
              ></div>
            </div>
          </div>
          <!-- 编辑、转为成交客户按钮 -->
          <div style="position: relative;top: -3px;">
            <el-button
              type="primary"
              size="small"
              @click="$refs.customDialog.showDialog = true ;"
              style="width:64px;font-size: 14px;"
            >编辑</el-button>
            <el-button
              type=""
              size="small"
              style="font-size: 14px;border:1px solid #066EB7; color:#066EB7;"
              @click="sendEmialJump"
            >发送邮件</el-button>
            <el-button
              v-if="detailData.soldStatus==10"
              size="small"
              style="width:112px; border:1px solid #066EB7; color:#066EB7; font-size: 14px;"
              @click="convertToTransaction"
            >转为成交客户</el-button>
          </div>
        </div>
        <div class="custom-pro-tags">
          <!-- 标签管理(客户标签展示区) -->
          <div
            class="custom-tags"
            style="display:flex; position:relative; color:#98A3B7;"
          >
            <div style="display:flex;" ref="tagContainer">
              <div
                id="tag"
                class="tag-apart"
                v-for="item in (firstLineTags || customerOption)"
                :key="item.id"
                @mouseenter="handleEnter(item.id)"
                @mouseleave="handleLeave"
                :style="{'background-color': `rgba(${
                    tagColors(item).rgb
                  },0.1)`}"
                v-show="item.id"
              >
                <div v-if="delTag == item.id" @click="deleteCustomerTags(item)">
                  <i class="el-icon-circle-close"></i>
                </div>
                <span
                  style="font-size:12px;padding:0 8px;"
                  :style="{color:item.color}"
                >{{item.name}}</span>
              </div>
            </div>
            <el-popover
              placement="bottom-end"
              trigger="hover"
              :visible-arrow="false"
              v-if="moreTags.length"
              popper-class="moreTagsPopover"
              :append-to-body="false"
            >
              <div class="moreTags">
                <div
                  v-for="item in moreTags"
                  :key="item.id"
                  @mouseenter="handleEnter(item.id)"
                  @mouseleave="handleLeave"
                  class="tag-apart"
                  :style="{'background-color': `rgba(${tagColors(item).rgb},0.1)`}"
                >
                  <div v-if="delTag == item.id" @click.once="deleteCustomerTags(item,1)">
                    <i class="el-icon-circle-close"></i>
                  </div>
                  <span
                    style="font-size:12px;padding:0 8px;"
                    :style="{color:item.color}"
                  >{{item.name}}</span>
                </div>
              </div>
              <img
                slot="reference"
                src="@/assets/image/common/pull-down.png"
                style="margin-top: -3px; width:7px; height:4px;margin-right: 12px;"
              />
            </el-popover>
          </div>
            <!-- 添加标签按钮 -->
            <el-button
              v-if="!tagManagement.length && !customerOption.length"
              class="tag-button"
              size="mini"
              @click="addTagDialog=true"
            >
              <span
                style=" position: relative; top: -2px; left:-7px; color:#98A3B7; font-family: SourceHanSansCN-Regular;"
              >+添加标签</span>
            </el-button>
            <el-popover
              v-else
              placement="right-start"
              trigger="click"
              popper-class="my-popover"
              v-model="visiblePopover"
              @show="showPopover"
              @hide="closePopover"
            >
              <div class="tag-popover">
                <div style=" display:flex; justify-content:space-between; margin-bottom:20px;">
                  <span style="font-weight: 600;font-size: 14px;color: #16181A;">标签</span>
                  <i style="cursor:pointer;" @click="visiblePopover=false" class="el-icon-close"></i>
                </div>
                <el-input
                  v-model.trim="searchTags"
                  placeholder="搜索标签"
                  size="small"
                  class="popoverInput"
                  clearable
                ></el-input>
                <div class="tag-popover-div">
                  <div
                    class="tag-popover-color"
                    v-for="item in copytagManagement"
                    :key="item.id"
                    @click="addCustomerTags(item)"
                  >
                    <span :style="{background:item.color}"></span>
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <div
                  class="tag-popover-button"
                  style="height:55px;margin-top:16px;margin-bottom:8px;border-top:1px solid #E5E8ED;"
                >
                  <div
                    @click="createTag"
                    style="display:block; border:none;font-size: 12px;margin: 16px 0 12px;cursor: pointer;"
                    size="mini"
                  >
                    <i
                      class="el-icon-circle-plus-outline"
                      style="margin-right: 6px;color: #4F5D78;"
                    ></i>
                    <span style="font-family: SourceHanSansCN-Regular;color: #4F5D78;">创建标签</span>
                  </div>
                  <div
                    @click="managementTag"
                    style="display:block;border:none;font-size: 12px;cursor: pointer;"
                    size="mini"
                  >
                    <i class="el-icon-s-grid" style="margin-right: 6px;color: #4F5D78;"></i>
                    <span style="font-family: SourceHanSansCN-Regular;color: #4F5D78;">管理标签</span>
                  </div>
                </div>
              </div>
              <el-button slot="reference" class="tag-button" size="mini">
                <span
                  style=" position: relative; top: -2px; left:-7px;color:#98A3B7;font-family: SourceHanSansCN-Regular;"
                >+添加标签</span>
              </el-button>
            </el-popover>
        </div>
        <!-- 第二行 -->
        <div class="custom-pro-two">
          <!-- 左边 -->
          <div class="detail-left">
            <div class="detail-one-custom" ref="detailOneRef">
              <ul>
                <!-- 所属行业 -->
                <li>
                  <div
                    class="label"
                  >所属行业:</div>
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :disabled="isShowTooltip"
                    :content="detailData.industryStr"
                  >
                    <div
                      class="value"
                      @mouseover="onMouseOver('industryTooltip')"
                    >
                      <span
                        ref="industryTooltip"
                        style="margin-left:1px;"
                      >{{detailData.industryStr || '暂无'}}</span>
                    </div>
                  </el-tooltip>
                </li>
                <!-- 雇员数量 -->
                <div class="curOff"></div>
                <li>
                  <div
                    class="label"
                  >雇员数量:</div>
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :disabled="isShowTooltip"
                    :content="detailData.employees+''"
                  >
                    <div
                      class="value"
                      @mouseover="onMouseOver('employeesRef')"
                    >
                      <span ref="employeesRef">{{detailData.employees || '暂无'}}</span>
                    </div>
                  </el-tooltip>
                </li>
                <!-- 企业年营收 -->
                <div class="curOff"></div>
                <li>
                  <div
                    class="label"
                  >企业年营收:</div>
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :disabled="isShowTooltip"
                    :content="(detailData.currencyStr ? detailData.currencyStr:'$' )+ detailData.copyRevenue"
                  >
                    <div
                      class="value"
                      @mouseover="onMouseOver('revenueRef')"
                    >
                      <span
                        ref="revenueRef"
                      >{{detailData.copyRevenue ? (detailData.currencyStr ? detailData.currencyStr:'$') + detailData.copyRevenue : '' || '暂无'}}</span>
                    </div>
                  </el-tooltip>
                </li>
                <!-- 邮政编码 -->
                <div class="curOff"></div>
                <li>
                  <div
                    class="label"
                  >邮政编码:</div>
                  <el-tooltip
                    effect="light"
                    placement="bottom-start"
                    :disabled="isShowTooltip"
                    :content="detailData.zipCode"
                  >
                    <div
                      class="value"
                      @mouseover="onMouseOver('zipCodeRef')"
                    >
                      <span ref="zipCodeRef">{{detailData.zipCode || '暂无'}}</span>
                    </div>
                  </el-tooltip>
                </li>
              </ul>
            </div>


            <!-- 公司地址 -->
            <div style="display:flex;margin-top: 8px;height:20px;">
              <div
                class="detail-pro"
                style="margin-right:9px;font-family: SourceHanSansCN-Regular;"
              >公司地址:</div>
              <div style="font-family: SourceHanSansCN-Regular;font-weight: 400;font-size: 12px;color: #16181A;" 
                v-if="!detailData.countryStr&&!detailData.stateStr&&!detailData.stateStr&&!detailData.address">暂无</div>
              <div
                v-else
                class="detail-product remark"
                style="
                width: 585px; 
                overflow: auto;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #16181A;"
              >{{detailData.countryStr|| ''}} {{detailData.stateStr||''}} {{detailData.cityStr||''}} {{detailData.address ||''}}</div>
            </div>
            <!-- 公司网址 -->
            <div style="display:flex;margin: 8px 0;height:20px;">
              <div
                class="detail-pro"
                style="font-weight: 400;font-size: 14px;color: #4F5D78;font-family: SourceHanSansCN-Regular;"
              >公司网址:</div>
              <div
                class="detail-product remark"
                style="
                width:580px; 
                word-wrap:break-word;
                overflow:auto;
                padding-left:5px;
                color:#066EB7;
                font-family: SourceHanSansCN-Regular;                "
              >
                <span
                  v-if="detailData.website"
                  style="cursor:pointer;"
                  @click="goWebsite"
                >{{detailData.website}}</span>
                <span
                  v-else
                  style="font-size: 12px;padding-left:0px;color: #16181A;font-family: SourceHanSansCN-Regular;"
                >暂无</span>
              </div>
            </div>
            <!-- 备注 -->
            <div style="display:flex;height:23px;">
              <div
                class="detail-pro"
                style="font-weight: 400;font-size: 14px;color: #4F5D78;font-family: SourceHanSansCN-Regular;"
              >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 注:</div>
              <div
                class="detail-product remark"
                style=" 
                  width: 580px; 
                  word-wrap: break-word;
                  padding-left:4px;
                  height: 40px; 
                  overflow-y: auto;
                  font-family: SourceHanSansCN-Regular;
                  font-weight: 400;
                  font-size: 14px;
                  color: #16181A;"
              >
                <span>{{detailData.remark || '暂无'}}</span>
              </div>
            </div>
          </div>
          <!-- 右边 -->
          <div class="detail-right">
            <div style="margin: 0px 24px ;">
              <div class="detail-pro">客户等级</div>
              <div
                class="detail-product"
                :style="'color:' + levelComp(detailData.level).color"
              >{{ detailData.levelStr | noText }}</div>
            </div>
            <div style="margin-right: 24px">
              <div class="detail-pro">客户来源</div>
              <div class="detail-product">{{detailData.sourceStr}}</div>
            </div>
            <div>
              <div class="detail-pro">跟进状态</div>
              <div
                class="detail-product"
                v-if="detailData.followStatus==20"
                style="color:#20B820;"
              >{{detailData.followStatusStr}}</div>
              <div
                class="detail-product"
                v-if="detailData.followStatus==10"
                style="color:#FF7F2A;"
              >{{detailData.followStatusStr}}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom:8px;"></div>
      <!-- 联系人列表 -->
      <div class="custom-concat">
        <div class="custom-concat-list fine-scroll-bar">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="height:44px;">
            <!-- 联系人 -->
            <el-tab-pane label="联系人" name="first" style="color:#4F5D78;" class="fine-scroll-bar">
              <ContactTable
                ref="contactTable"
                :copyDetailData="copyDetailData"
                @closeCustomer="closeCustomer"
                @showDetailDialog="handleShowContactDetailDialog"
              />
            </el-tab-pane>
            <!-- 邮件发送记录 -->
            <el-tab-pane label="邮件发送记录" name="second">
              <emailSendRecord
                ref="customerEmail"
                :list="emailSendList"
                :isLoading="isEmailLoading"
                :totalNum="emailTotalNum"
                @getEmailList="getAllContactEmailSendRecord"
              />
            </el-tab-pane>
            <!-- 操作日志 -->
            <el-tab-pane label="操作日志" name="third">
              <OperationLog
                ref="customerLog"
                :list="logList"
                :isLoading="isLoading"
                :totalNum="logTotalNum"
                @getLogList="getLogList"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- ? 这里是跟进模块代码 -->
        <div style="flex: auto;background:#fff;">
          <CustomerFollow
            ref="customerFollow"
            @anewGetDetail="anewGetDetail"
            class="CustomerFollow"
            :customerId="switchData.id"
            :supplier-customer-user-vo-list="detailData.supplierCustomerUserVoList || []"
          ></CustomerFollow>
        </div>
      </div>
    </div>

    <!-- 编辑客户信息 -->
    <EditorDialog
      ref="customDialog"
      :copyDetailData="copyDetailData"
      @getCustomerDetail="getCustomerDetail"
      @getLogList="getLogList"
    />
    <!-- 创建、编辑标签 -->
    <el-dialog
      :title=" tagMark==0 ?'创建标签' :'编辑标签'"
      width="440px"
      custom-class="createTag"
      :visible.sync="addTagDialog"
      :before-close="handleClose"
      :append-to-body="true"
      @closed="isSubmiting = false"
    >
      <div style="display:flex; position:relative;">
        <div :class="{'createTag-div createTag-div1':isActive ==1} " v-if="isActive == 1"></div>
        <div :class="{'createTag-div createTag-div2':isActive ==2} " v-if="isActive == 2"></div>
        <div :class="{'createTag-div createTag-div3':isActive ==3} " v-if="isActive == 3"></div>
        <div :class="{'createTag-div createTag-div4':isActive ==4} " v-if="isActive == 4"></div>
        <div :class="{'createTag-div createTag-div5':isActive ==5} " v-if="isActive == 5"></div>
        <el-input
          v-model="tags"
          placeholder="请输入标签名称"
          maxlength="20"
          show-word-limit
          style="width:376px;"
        ></el-input>
      </div>
      <ul>
        <li :class="{'activeName':isActive ==1}" @click="choiceTag(1)">
          <div style="background: #20B820;"></div>
        </li>
        <li :class="{'activeName':isActive ==2}" @click="choiceTag(2)">
          <div style="background: #9255DE;"></div>
        </li>
        <li :class="{'activeName':isActive ==3}" @click="choiceTag(3)">
          <div style="background: #2F53EB;"></div>
        </li>
        <li :class="{'activeName':isActive ==4}" @click="choiceTag(4)">
          <div style="background: #FF7F2A;"></div>
        </li>
        <li :class="{'activeName':isActive ==5}" @click="choiceTag(5)">
          <div style="background: #F2BD00;"></div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" style="width:56px;color: #16181A" @click="cancelTag">取 消</el-button>
        <el-button
          size="small"
          style="width:56px;"
          type="primary"
          :disabled="tags.trim()==''"
          @click="confirmTag"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 管理标签 -->
    <el-dialog
      title="管理标签"
      width="480px"
      custom-class="managementTag"
      :visible.sync="managementDialog"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div v-if="tagManagement.length==0">
        <img
          src="../../assets/nolevel.png"
          style="width: 197px;height: 140px; display:block; margin:0 auto;"
          alt
        />
        <span style="display:block;text-align:center;color: #16181A;">
          暂无标签，快去
          <span style="color:#066EB7; cursor:pointer;" @click="goCreateTag">创建标签</span>吧~
        </span>
      </div>
      <div v-else style="height:350px; overflow:auto;">
        <el-input
          v-model.trim="searchTags"
          placeholder="搜索标签"
          size="small"
          class="popoverInput"
          style="width: 390px; margin-left: 30px;margin-bottom:10px;"
          clearable
        ></el-input>
        <div
          class="management-label"
          v-for="item in copytagManagement"
          :key="item.id"
          @mouseenter="mouseenter(item.id)"
          @mouseleave="mouseleave"
        >
          <div>
            <span class="managementTagColor" :style="{background:item.color} "></span>
            <span style="font-size: 14px;color: #16181A;">{{item.name}}</span>
          </div>
          <div v-if="activeIndex == item.id" style="width:76px;margin-right:18px;">
            <span class="management-label-edit" @click="editTag(item,1)">编辑</span>
            <span class="management-label-delete" @click="deleteTag(item)">删除</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 套餐购买 -->
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" :typeOpen="false"/>

    <!-- 发送邮件提示 -->
    <el-dialog
      title="发送提示"
      :visible.sync="dialogVisible"
      width="570px"
      :modal="true" 
      :append-to-body="true"
      custom-class="Sendreminder"
      :close-on-click-modal="false"
      @closed="closeCustomerFun"
      >
      <div class="reason"> <i class="iconfont icon-Vector"></i> 无法发送，具体原因如下：</div>
      <div v-if="customerUserVosList.length>0">
        <div  v-for="item in customerUserVosList" :key="item.id">
          <div v-if="item.emailStateType==1" class="emailStateType">
            <span class="email" @click="handleShowContactDetailDialog(item)">{{ item.contactName }}</span> 
            <span >(<span class="email" @click="handleShowContactDetailDialog(item)">{{ item.email }}</span>) 该客户已退订邮件，建议使用个人邮箱发送邮件</span>
          </div>
          <div v-if="item.emailStateType==2" class="emailStateType">
            <span class="email" @click="handleShowContactDetailDialog(item)">{{ item.contactName }}</span>
            <span >(<span class="email" @click="handleShowContactDetailDialog(item)">{{ item.email }}</span>) 该客户邮箱存在于手动排除列表，需您手动移除后才可继续发送邮件&nbsp;&nbsp;&nbsp;&nbsp;<span class="email" @click="toStatistics(item)">去移除  ></span> </span>
          </div>
          <div v-if="item.emailStateType==3" class="emailStateType">
            <span class="email" @click="handleShowContactDetailDialog(item)">{{ item.contactName }}</span>
            <span>(<span class="email" @click="handleShowContactDetailDialog(item)">{{ item.email }}</span>) 该客户邮箱地址可能不正确或其他原因，无法发送邮件</span>
          </div>
          <div v-if="item.emailStateType==4" class="emailStateType">
            <span class="email" @click="handleShowContactDetailDialog(item)">{{ item.contactName }}</span>
            <span>(<span class="email" @click="handleShowContactDetailDialog(item)">{{ item.email }}</span>) 该客户邮箱已满或邮箱远程服务器暂时性故障等，导致邮件暂时不能顺利被送达</span>
          </div>
        </div>
      </div>
      <div v-if="customerUserVosList.length==0">
        <div class="emailStateType">
          <!-- <span >{{ item.contactName }}</span> -->
          <span >该客户邮箱存在于手动排除列表，需您手动移除后才可继续发送邮件&nbsp;&nbsp;&nbsp;&nbsp;<span class="email" @click="toStatistics({email:detailData.supplierCustomerUserEmailList[0]})">去移除  ></span> </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="closeCustomerFun">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

import EditorDialog from "./editorDialog";
import setClipBoardText from "@/utils/clipboard";
import CustomerFollow from "@/components/customer-follow/index.vue";
import ContactTable from "@/components/custom/contactTable.vue";
import OperationLog from "@/components/custom/OperationLog";
import customerListMinxis from "@/mixins/customerList.js";
import emailSendRecord from '@/components/custom/emailSendRecord'
import vipBoxDialog from "@/components/common/VIPdialog"
import {
  customerDetail,
  followUpCustomer,
  convertToTransaction,
  // deleteContact,
  addCustomerTag,
  deleteCustomerTag,
  tagsList,
  saveTags,
  delTags,
  editTags,
  logList,
  allContactEmailSendRecord,
  customerSendEmailVerify
} from "@/utils/api/customerdetail";
import { newTabLink } from "@/utils/common.js";

export default {
  components: {
    EditorDialog,
    CustomerFollow,
    ContactTable,
    OperationLog,
    emailSendRecord,
    vipBoxDialog
  },
  mixins: [customerListMinxis],

  props: {
    // 切换公司详情需要用到的字段
    companyData: {
      type: Object,
      default() {
        return {
          id: null, // 当前id
          ids: [], // 当前页的id集合
          index: null // 当前索引
        };
      }
    },
    isList: {
      default: true
    }
  },
  data() {
    return {
      isSubmiting: false, //表单提交状态（是否正在提交）
      activeName: "first",
      showDetailDialog: false,
      showDialog: false,
      tagDialog: false,
      addTagDialog: false,
      managementDialog: false,
      showStar: false,
      visiblePopover: false,
      tagVisible: false,
      deleteVisible: false,
      isShowTooltip: false,
      tagColor: "#20B820",
      id: 0, //编辑的tagId
      delTag: 0, //删除标签标记
      customerOption: [], //我的客户标签
      excludeTags: [],
      detailData: {}, //详情数据
      copyDetailData: {},
      switchData: {
        ids: [],
        id: null,
        index: 0
      },

      contactList: [], //联系人列表数据
      copyContactList: [],

      tagMark: 0,
      activeIndex: -1,
      isActive: 1, //标签颜色index
      tags: "",
      searchTags: "",
      tagManagement: [], //标签管理

      logList: [], //操作日志列表
      
      saveId: {},
      arr: [], //过滤标签集合
      contactDetailData: {},
      contactDetailShow: false,
      tagMaxWidth: "",
      moreTags: [],
      firstLineTags: null,
      industryStrLength: "",
      backMsg: false, //详情切换数据
      isLoading: false,
      isClick: false,
      offsetWidth: 0,
      liTotalOffsetWidth: 0,
      logTotalNum: 0,
      emailTotalNum:0,
      emailSendList:[],//邮件发送记录
      isEmailLoading: false,
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      customerUserVosList:[],
      dialogVisible:false
    };
  },
  methods: {
    //  跳转到手动排除
    toStatistics(item){
      console.log(item)
      // detailData  detailData.supplierCustomerUserEmailList[0]
      if(item){
        let routeUrl =this.$router.resolve({
          name:`statistics`,
          query:{
            email:item.email,
          }
        }).href
        window.open(routeUrl, '_blank');
      }else{
        let routeUrl =this.$router.resolve({
          name:`statistics`,
          query:{
            email:this.detailData.supplierCustomerUserEmailList[0],
          }
        }).href
        window.open(routeUrl, '_blank');
      }

    },
    mouseover(val) {
      if (val == 1) {
        let revenueRef = this.$refs.revenueRef;
        this.offsetWidth = revenueRef.offsetWidth;
      } else if (val == 2) {
        let refIndustry = this.$refs.industryRef;
        this.offsetWidth = refIndustry.offsetWidth;
      } else if (val == 3) {
        let refZipCode = this.$refs.zipCodeRef;
        this.offsetWidth = refZipCode.offsetWidth;
      } else {
        let employeesRef = this.$refs.employeesRef;
        this.offsetWidth = employeesRef.offsetWidth;
      }
    },
    // 网址跳转
    goWebsite() {
      let url = this.detailData.website;
      // 判断当前网址有没有包含协议前缀，如果没有，拼接 //
      if (!/^(http|https):\/\//i.test(url)) {
        url = "//" + url;
      }
      window.open(url);
    },
    showPopover() {
      this.customerOption.forEach(item => {
        this.arr.push(item.id);
      });
      this.getTagsList(this.arr);
    },
    closePopover() {
      this.arr = [];
      this.searchTags = "";
    },

    //日期格式化
    handleFormatDateAndTime(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD HH:mm:ss");
      }
      return "--";
    },

    closeCustomer(val) {
      this.showDetailDialog = val;
    },
    handleEnter(index) {
      this.delTag = index;
    },
    handleLeave() {
      this.delTag = 0;
    },
    setClipBoardText,
    //获取客户详情
    getCustomerDetail(id, mark) {
      const params = { id };
      customerDetail(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.industryStrLength = res.data.industryStr
              ? res.data.industryStr.length
              : null;
            this.detailData = res.data || {};
            this.customerOption = this.detailData.supplierTagVoList || [];
            if (mark == 1) {
              this.arr = [];
              this.customerOption.forEach(item => {
                this.arr.push(item.id);
              });
              this.getTagsList(this.arr);
            }
            // 处理标签展示问题
            this.firstLineTags = null;
            this.moreTags = [];
            this.$nextTick(() => {
              this.handleResize();
            });
            this.detailData.revenue = res.data.revenue;
            this.detailData.copyRevenue = res.data.revenue
              ? Number(res.data.revenue).toLocaleString()
              : null;
            this.copyDetailData = JSON.parse(JSON.stringify(this.detailData));
          }
        })
        .catch(err => {
          console.error("获取客户详情失败", err);
        });
    },
    // 关注客户
    focusCustomer() {
      this.showStar = !this.showStar;
      if (this.detailData.attentionStatus == 10) {
        const params = {
          attentionStatus: 20,
          id: this.detailData.id
        };
        followUpCustomer(params)
          .then(() => {
            this.$message({
              message: "已特别关注",
              type: "success",
              duration: 1500
            });
          })
          .catch(res => console.error("特别关注失败", res));

        this.detailData.attentionStatus = 20;
      } else {
        const params = {
          attentionStatus: 10,
          id: this.detailData.id
        };
        followUpCustomer(params)
          .then(() => {
            this.$message({
              message: "取消特别关注",
              type: "warning",
              duration: 1500
            });
          })
          .catch(res => console.error("取消特别关注失败", res));
        this.detailData.attentionStatus = 10;
      }
    },
    // 转为成交客户(确认按钮)
    convertToTransaction() {
      let confirmRes = this.$confirm("确认将该客户转为成交客户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = {
            id: this.detailData.id
          };
          convertToTransaction(params)
            .then(res => {
              if (res.rspResult.bizCode == 200) {
                setTimeout(() => {
                  this.$emit("closeDetail", true);
                }, 1000);
              }
            })
            .catch(err => {
              console.error("转为成交客户失败", err);
            });
        })
        .catch(err => {
          return err;
        });
    },
    // tab选项
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.$refs.contactTable.currentPage = 1;
        this.$refs.contactTable.handleCurrentChange(1);
      } else if(tab.index == 1){
        // console.log('邮件发送记录')
        let currentPage = (this.$refs.customerEmail.currentPage = 1);
        this.getAllContactEmailSendRecord(currentPage)
      }else {
        let current = (this.$refs.customerLog.currentPage = 1);
        this.getLogList(current);
      }
    },
    // 获取操作日志
    getLogList(curPage) {
      this.isLoading = true;
      const params = {
        id: this.switchData.id,
        curPage: curPage ? curPage : this.currentPage,
        pageSize: 10
      };
      logList(params)
        .then(res => {
          this.isLoading = false;
          if (res.rspResult.bizCode == 200) {
            this.logList = res.rspPageData.list || [];
            this.logTotalNum = res.rspPageData.totalNum;
          }
          this.backMsg = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.error("获取操作日志失败", err);
        });
    },
    // 获取邮件发送记录
    getAllContactEmailSendRecord(curPage) {
      this.isLoading = true;
      const params = {
        id: this.switchData.id,
        curPage: curPage ? curPage : this.currentPage,
        pageSize: 5
      };
      allContactEmailSendRecord(params)
        .then(res => {
          this.isLoading = false;
          if (res.rspResult.bizCode == 200) {
            this.emailSendList = res.rspPageData.list || [];
            this.emailTotalNum = res.rspPageData.totalNum;
            console.log(this.emailSendList)
          }
          this.backMsg = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.error("获取邮件发送记录", err);
        });
    },
    //关闭标签弹框
    handleClose() {
      this.tags = "";
      this.searchTags = "";
      this.addTagDialog = false;
      this.isActive = 1;
      this.tagMark = 0;
      this.managementDialog = false;
    },
    // 添加客户标签
    addCustomerTags(val) {
      if (this.isClick) return;
      this.isClick = true;
      const params = {
        customerId: this.copyDetailData.id,
        tagId: val.id
      };
      addCustomerTag(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.arr.push(val.id);
            this.getTagsList(this.arr);
            this.getCustomerDetail(this.copyDetailData.id);
          }
          this.isClick = false;
        })
        .catch(err => {
          this.isClick = false;
          console.error("添加客户标签失败", err);
        });
    },
    // 删除客户标签
    deleteCustomerTags(val) {
      if (this.isClick) return;
      this.isClick = true;

      const params = {
        customerId: this.copyDetailData.id,
        tagId: val.id
      };
      deleteCustomerTag(params)
        .then(res => {
          setTimeout(() => {
            this.isClick = false;
          }, 500);
          if (res.rspResult.bizCode == 200) {
            this.$message({
              type: "success",
              message: "客户标签删除成功",
              duration: 1500
            });
            let a = this.customerOption.filter(item => {
              return item.id != val.id;
            });
            a.forEach(item => {
              this.arr.push(item.id);
            });
            this.getTagsList(this.arr ? this.arr : []);
            this.arr = [];
            this.getCustomerDetail(this.copyDetailData.id);
          }
        })
        .catch(err => {
          this.isClick = false;
          console.error("删除客户标签失败", err);
        });
    },
    // 保存标签
    addTag() {
      const params = {
        color: this.tagColor,
        name: this.tags.trim()
      };
      saveTags(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.saveId = res.data;
            this.$message({
              type: "success",
              message: "添加成功",
              duration: 1500
            });
            this.tagMark = 0;
            this.tags = "";
            this.isActive = 1;
            this.tagColor = "#20B820";
            if (this.customerOption.length < 20) {
              this.addCustomerTags(this.saveId);
            } else {
              this.getTagsList(this.arr);
              this.getCustomerDetail(this.copyDetailData.id);
            }
            this.addTagDialog = false;
          }
          this.isSubmiting = false;
        })
        .catch(err => {
          this.isSubmiting = false;
          console.error("保存标签失败", err);
        });
    },
    // 编辑接口
    editTags() {
      const params = {
        color: this.tagColor,
        id: this.id,
        name: this.tags
      };
      editTags(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.$message({
              type: "success",
              message: "编辑成功",
              duration: 1500
            });
            this.tagMark = 0;
            this.addTagDialog = false;
            this.getTagsList();
            this.getCustomerDetail(this.copyDetailData.id);
          }
          this.isSubmiting = false;
        })
        .catch(err => {
          this.isSubmiting = false;
          console.error("保存标签失败", err);
        });
    },
    // 确定新建、编辑标签
    confirmTag() {
      if (this.isSubmiting) return;
      this.isSubmiting = true;
      if (this.tagMark == 0) {
        this.addTag();
      } else {
        this.editTags();
      }
      this.getLogList();
    },
    // 取消新建、编辑标签
    cancelTag() {
      this.addTagDialog = false;
      this.tags = "";
      this.tagMark = 0;
      this.isActive = 1;
    },
    // 获取标签列表
    getTagsList(val) {
      const params = {
        excludeTags: val ? val : []
      };
      tagsList(params)
        .then(res => {
          if (res.rspResult.bizCode == 200) {
            this.tagManagement = res.rspListData.list || [];
          }
        })
        .catch(err => console.error("获取标签列表失败", err));
    },
    // 选择标签颜色
    choiceTag(val) {
      this.isActive = val;
      if (this.isActive == 1) {
        this.tagColor = "#20B820";
      } else if (this.isActive == 2) {
        this.tagColor = "#9255DE";
      } else if (this.isActive == 3) {
        this.tagColor = "#2F53EB";
      } else if (this.isActive == 4) {
        this.tagColor = "#FF7F2A";
      } else if (this.isActive == 5) {
        this.tagColor = "#F2BD00";
      } else {
        this.tagColor = "#20B820";
      }
    },
    mouseenter(index) {
      this.activeIndex = index;
    },
    mouseleave(index) {
      this.activeIndex = -1;
    },
    // 编辑标签
    editTag(item, val) {
      this.tagColor = item.color;
      this.tags = item.name;
      this.id = item.id;
      this.tagMark = val;
      this.addTagDialog = true;
      switch (item.color) {
        case "#20B820":
          this.isActive = 1;
          break;
        case "#9255DE":
          this.isActive = 2;
          break;
        case "#2F53EB":
          this.isActive = 3;
          break;
        case "#FF7F2A":
          this.isActive = 4;
          break;
        case "#F2BD00":
          this.isActive = 5;
          break;
      }
    },
    // 删除标签
    deleteTag(item) {
      let confirmRes = this.$confirm(
        "删除后，相关客户将不再显示该标签",
        "确定删除该标签？",
        {
          confirmButtonText: "确认删除",
          cancelButtonText: "再想想",
          type: "warning",
          customClass: "deleteTagMessage"
        }
      )
        .then(() => {
          const params = {
            id: item.id
          };
          delTags(params)
            .then(res => {
              if (res.rspResult.bizCode == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                  duration: 1500
                });
              }
              this.getCustomerDetail(this.copyDetailData.id);
              this.getTagsList();
              this.getLogList();
            })
            .catch(err => console.error("删除联系人失败", err));
        })
        .catch(err => {
          return err;
        });
    },
    // 创建标签
    createTag() {
      this.visiblePopover = false;
      this.addTagDialog = true;
    },
    // 管理标签
    managementTag() {
      this.visiblePopover = false;
      this.managementDialog = true;
      this.getTagsList();
    },
    goCreateTag() {
      this.managementDialog = false;
      this.addTagDialog = true;
    },

    // 跟进后，重新获取当前详情
    anewGetDetail() {
      this.getCustomerDetail(this.switchData.id);
      this.$refs.customerFollow.getList();
    },
    // 标签颜色
    tagColors(item) {
      let rgb = "";
      switch (item.color) {
        case "#20B820":
          rgb = "32, 184, 32";
          break;
        case "#9255DE":
          rgb = "146, 85, 222";
          break;
        case "#2F53EB":
          rgb = "47, 83, 235";
          break;
        case "#FF7F2A":
          rgb = "255, 127, 42";
          break;
        case "#F2BD00":
          rgb = "242, 189, 0";
          break;
      }
      return {
        rgb
      };
    },
    // 收起按钮
    drawerClose() {
      this.$emit("closeDetail", false);
      this.activeName = "first";
    },
    handleShowContactDetailDialog(data) {
      this.$emit("switchDetail", false, {
        id: Number(data.id) ,
        ids: [Number(data.id)],
        cid: Number(data.id),
        cids: [Number(data.id)],
        index: 0
      });
    },
    // 上一个公司详情
    preCompany() {
      this.backMsg = true;
      this.switchData.id = this.switchData.ids[this.switchData.index - 1];
      this.switchData.index -= 1;
      let current = (this.$refs.customerLog.currentPage = 1);
      const ele = document.querySelector('.custom-concat-list')
      ele.scrollTop =0
      this.getLogList(current);
      this.getAllContactEmailSendRecord(current)
      this.getCustomerDetail(this.switchData.id, 1);
      this.$emit("turnPage", true, {
        id: this.switchData.id,
        ids: [this.switchData.id],
        index: 0
      });
    },
    // 下一个公司详情
    nextCompany() {
      this.backMsg = true;
      // 这里更新 this.switchData.id 为下一个，this.switchData.index + 1，然后再去请求下一条详情
      this.switchData.id = this.switchData.ids[this.switchData.index + 1];
      this.switchData.index += 1;
      let current = (this.$refs.customerLog.currentPage = 1);
      const ele = document.querySelector('.custom-concat-list')
      ele.scrollTop =0
      this.getLogList(current);
      this.getAllContactEmailSendRecord(current)
      this.getCustomerDetail(this.switchData.id, 1);

      this.$emit("turnPage", true, {
        id: this.switchData.id,
        ids: [this.switchData.id],
        index: 0
      });
    },
    // 当联系人详情关闭时，重新请求客户详情
    contactDetailAnewGetDetail() {
      // 需要重新请求的
      this.getCustomerDetail(this.switchData.id);
    },

    // 计算标签宽度
    handleResize() {
      const tagContainer = this.$refs.tagContainer;
      if (tagContainer) {
        const tagElems = tagContainer.querySelectorAll(".tag-apart");
        const tagContainerWidth = 500;
        const tagMarginRight = 8;
        let tagTotalWidth = 0;
        let tagIndex = 0;
        if (tagElems.length) {
          // 计算一行能放下多少个标签
          while (
            tagTotalWidth + tagElems[tagIndex].offsetWidth + tagMarginRight <=
            tagContainerWidth
          ) {
            tagTotalWidth += tagElems[tagIndex].offsetWidth + tagMarginRight;
            tagIndex++;
            if (tagIndex >= tagElems.length) {
              break;
            }
          }
        }
        // 将第一行的单独放到一个数组去
        if (tagElems.length) {
          const firstLineTags = [];
          for (let i = 0; i < tagIndex; i++) {
            firstLineTags.push(this.customerOption[i]);
          }
          this.firstLineTags = firstLineTags;
        }
        // 将一行放不下的标签放入moreTags数组中，并更新tagMaxWidth
        if (tagIndex < tagElems.length) {
          this.moreTags = this.customerOption;
          // const moreTags = [];
          // for (let i = tagIndex; i < tagElems.length; i++) {
          //   moreTags.push(this.customerOption[i]);
          // }
          // this.moreTags = moreTags;
          this.tagMaxWidth = "";
        } else {
          this.moreTags = [];
          // 计算标签的最大宽度
          const maxWidth = Math.floor(
            (tagContainerWidth - tagTotalWidth) / tagIndex
          );
          this.tagMaxWidth = `${maxWidth}px`;
        }
      }
    },

    // 处理Tooltip溢出时才显示。
    onMouseOver(str) {
      // 内容超出，显示文字提示内容
      if (str == "customNameStrTootip") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      } else if (str == "industryTooltip") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      } else if (str == "employeesRef") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      } else if (str == "revenueRef") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      } else if (str == "zipCodeRef") {
        const tag = this.$refs[str];
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
      }
    },
    // 发送邮件
    sendEmialJump(){
      // console.log(909090909)
      console.log(this.$route.name)
      let name=this.$route.name
      if(this.$route.name=='mail-list'){
          name='potential'
      }
      
      let params={
        "id": this.switchData.id,
      }
      customerSendEmailVerify(params).then(res=>{
        console.log(res)
        if(res.rspResult.bizCode==200){
          if(res.data.verifySuccess==1){
            let routeUrl =this.$router.resolve({
              name:`${name}SendEmail`,
              query:{
                customerId:this.copyDetailData.id,
              }
            }).href
            window.open(routeUrl, '_blank');
          }else{
            this.customerUserVosList=res.data.customerUserVos
            this.dialogVisible=true
            window.localStorage.setItem('dialogFlags', this.copyDetailData)
          }
        }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
          this.vipCode=res.rspResult.bizCode
          this.$refs.vipBoxDialog.centerDialogVisible=true
        }else if(res.rspResult.bizCode==21009){
          this.customerUserVosList=[]
          // this.dialogVisible=true
          this.$message({
            dangerouslyUseHTMLString: true,
            message: `<div >该客户邮箱存在于手动排除列表，需您手动移除后才可继续发送邮件<button style="color:rgb(6, 110, 183);cursor: pointer;border: none;background: none; margin-left: 12px;" onclick ="toStatistics()">去移除  ></button> </div>`,
            type: 'error',
            // duration: 3000
          });
        }else{
          this.$message.error(res.rspResult.message)
        }
      })
      
    },
    // 关闭
    closeCustomerFun(){
      this.dialogVisible = false
      if(window.localStorage.getItem('dialogFlags')){
        window.localStorage.removeItem('dialogFlags')
      }
    }
  },
  created() {
    // 然后拿 this.switchData.id 去请求当前详情
    this.switchData = JSON.parse(JSON.stringify(this.companyData));
    this.getCustomerDetail(this.switchData.id);
    // this.getLogList()
    this.getTagsList();
    
  },
  mounted() {
    // window全局对象上定义一个这样的方法
    window.toStatistics = this.toStatistics
    if(window.localStorage.getItem('dialogFlags')){
      this.sendEmialJump()
    }
  },
  computed: {
    copytagManagement() {
      var _search = this.searchTags;
      if (_search) {
        //不区分大小写处理
        var reg = new RegExp(_search, "ig");
        //filter过滤匹配，有则返回当前，无则返回所有
        return this.tagManagement.filter(function(e) {
          // //匹配所有字段
          // return Object.keys(e).some(function(key) {
          //   return e[key].match(reg);
          // })
          // 匹配某个字段
          return e.name.match(reg);
        });
      }
      return this.tagManagement;
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-detail {
  // font-family: SourceHanSansCN-Medium;
  .custom-tags {
    > div {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .closeButton {
    width: 66px;
    height: 28px;
    position: fixed;
    right: 1010px;
    top: 39px;
    box-shadow: 2px 0 4px 0 #0058b633;
    border-radius: 2px;
    background-color: #318ced;
    border-color: #318ced;
  }
  .custom-company-profile {
    height: 211px;
    padding: 20px 24px 0 24px;
    background: #fff;
    .custom-pro-one {
      display: flex;
      justify-content: space-between;
      .custom-one-title {
        color: #16181a;
        font-size: 16px;
        font-weight: 700;
        font-family: SourceHanSansCN-Bold;
        // width: 185px;
        p {
          max-width: 600px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .custom-pro-tags {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .tag-button {
        width: 71px;
        height: 24px;
        font-size: 12px;
        margin-left: 8px;
        border: 1px dashed #cfd5df;
      }
    }
    .custom-pro-two {
      display: flex;
      justify-content: space-between;
      height: 84px;
      line-height: 20px;
      .detail-left {
        // TODO 这里宽度减30 
        width: 616px;
        .detail-one {
          display: flex;
          .curOff {
            height: 12px;
            border-right: 1px solid #e5e8ed;
            position: relative;
            top: 5px;
          }
          .detail-companyMsg {
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #16181a;
          }
          .detail-product {
            font-size: 14px;
            padding-right: 22px;
            color: #16181a;
            font-family: SourceHanSansCN-Medium;
          }
          .detail-product:last-child {
            padding-right: 0;
          }
          .detail-pro:first-child {
            margin-left: 0;
          }
        }


        // TODO 这里尝试优化样式
        .detail-one-custom {
          font-size: 14px;
          >ul {
            display:flex;
            width:677px;
            >li {
              display:flex;
              // flex: auto;
              .label {
                margin-right: 8px;
                font-family: SourceHanSansCN-Regular;
                flex-shrink: 0;
                color:#4f5d78;
              }
              .value {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-family: SourceHanSansCN-Regular;
                color: #16181A;
              }
              &:first-of-type {
                .value {
                  max-width: 116px;
                }
              }
              &:nth-of-type(2) {
                .value {
                  max-width: 46px;
                }
              }
              &:nth-of-type(3) {
                .value {
                  max-width: 86px;
                }
              }
              &:nth-of-type(4) {
                .value {
                  max-width: 66px;
                }
              }
            }
          }
          .curOff {
            height: 12px;
            border-right: 1px solid #e5e8ed;
            position: relative;
            top: 5px;
            margin: 0 12px;
          }
        }


        .detail-pro {
          height: 12px;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          margin-right: 6px;
          margin-left: 22px;
          font-family: SourceHanSansCN-Medium;
          flex-shrink: 0;
        }
        .detail-pro:first-child {
          margin-left: 0;
        }
        .detail-product {
          font-size: 14px;
          color: #16181a;
        }
      }
      .detail-right {
        display: flex;
        // TODO 这里宽度加了30
        height: 78px;
        padding-top: 6px;
        position: relative;
        top: 6px;
        line-height: 42px;
        border-left: 1px solid #e5e8ed;

        .detail-pro {
          height: 12px;
          font-size: 14px;
          color: #4f5d78;
          margin-bottom: 16px;
        }
        .detail-product {
          font-size: 14px;
          color: #16181a;
        }
      }
    }
  }
  .custom-concat {
    display: flex;
    padding: 0px 8px;
    .custom-concat-list {
      width: 572px;
      background: #fff;
      margin-right: 8px;
      padding: 0 24px 30px 24px;
      height: calc(100vh - 271px);
      overflow-y: auto;
    }
    ::v-deep .el-tabs {
      .el-tabs__item {
        font-size: 14px;
        height: 46px;
        line-height: 46px;
      }
    }
  }
}
.tag-apart {
  position: relative;
  height: 24px;
  margin-right: 12px;
  line-height: 22px;
  text-align: center;
  border-radius: 2px;
  // overflow: hidden;
  > div {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #f5f7fa;
    position: absolute;
    right: -4px;
    top: -7px;
    z-index: 1;
    cursor: pointer;
  }
  .el-icon-circle-close {
    position: absolute;
    left: -1px;
    top: -1px;
  }
}
.my-popover {
  .tag-popover {
    .tag-popover-div {
      height: 200px;
      overflow: auto;
      margin-top: 16px;
      line-height: 24px;
      color: #16181a;
      overflow: auto;
      .tag-popover-color {
        cursor: pointer;
        span:first-child {
          position: relative;
          top: -1px;
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 10px;
        }
        span:last-child {
          font-family: SourceHanSansCN-Regular;
          font-size: 12px;
          color: #16181a;
        }
      }
      .tag-popover-color:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

// 管理标签样式
.management-label {
  display: flex;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
  padding: 0 32px 0 33px;
  .managementTagColor {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: relative;
    top: -3px;
    margin-right: 3px;
  }
  .management-label-edit {
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #066eb7;
    margin-right: 18px;
  }
  .management-label-delete {
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #ef2a2a;
  }
}
.management-label:hover {
  background: #f5f7fa;
}

::v-deep .popoverInput {
  width: 243px;
  height: 31px;
  .el-input__inner {
    font-family: SourceHanSansCN-Regular;
    color: #16181a;
  }
}
::v-deep .managementTag {
  .el-dialog__header {
    padding: 30px 0 16px 32px;
    .el-dialog__title {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
    }
  }
  .el-dialog__body {
    padding: 0 0 32px;
  }
  .el-dialog__headerbtn {
    top: 32px;
    right: 32px;
  }
}
::v-deep .addtag {
  .el-dialog__footer {
    border-top: 1px solid #f5f7fa;
    text-align: left;
  }
}
::v-deep .createTag {
  .createTag-div {
    position: absolute;
    top: 9px;
    left: 14px;
    width: 14px;
    height: 14px;
    z-index: 5;
    margin-right: 20px;
    border-radius: 2px;
  }
  .createTag-div1 {
    background-color: #20b820;
  }
  .createTag-div2 {
    background-color: #9255de;
  }
  .createTag-div3 {
    background-color: #2f53eb;
  }
  .createTag-div4 {
    background-color: #ff7f2a;
  }
  .createTag-div5 {
    background-color: #f2bd00;
  }
  ul {
    display: flex;
    width: 376px;
    padding-left: 0;
    border-bottom: 1px solid #e5e8ed;
    margin: 0;
    li {
      width: 28px;
      height: 28px;
      margin: 20px 12px 20px 0;
      border-radius: 4px;
      div {
        width: 20px;
        height: 20px;
        border-radius: 2px;
        margin: 4px;
      }
    }
    li.activeName {
      border: 1px solid #4f5d78;
    }
  }
  .el-dialog__title {
    color: #16181a;
    font-weight: 500;
    font-size: 16px;
  }
  .el-dialog__headerbtn {
    top: 32px;
    right: 32px;
  }
  .el-dialog__header {
    padding: 28px 32px 0 32px;
  }
  .el-input__inner {
    padding: 0 15px 0 41px;
    color: #16181a;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular;
  }
  .el-input__inner::placeholder {
    color: #98a3b7;
  }

  .el-dialog__body {
    padding: 24px 32px 0 32px;
  }
  .el-dialog__footer {
    padding: 20px 32px 32px 20px;
  }
  .el-button--small {
    padding: 9px 13px;
  }
  .el-input__count-inner {
    color: #98a3b7;
    font-size: 12px;
  }
}
::v-deep .lineinDialog {
  .el-dialog__body {
    padding: 0 20px;
  }
  .el-dialog__footer {
    padding: 32px;
  }
}
::v-deep .Sendreminder{
  border-radius: 4px;
  .reason{
    color: #FAAD14;
    margin-bottom: 12px;
  }
  .el-dialog__body{
    padding: 0px 26px;
    height: 180px;
    overflow: auto;
    color: #16181a;
  }
  .el-dialog__header{
    padding: 26px ;
    padding-bottom: 20px;
    .el-dialog__title{
      font-size: 16px;
      color: #16181A;
    }
  }
  /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
  .emailStateType{
    margin-bottom: 8px;
    margin-left: 20px;
    .email{
      color: #066EB7;
      margin-right: 4px;
      cursor: pointer;
    }
  }
}
.icon-Vector{
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px;
}
::v-deep.el-input__inner::placeholder {
  color: #98a3b7;
}
// 分页样式
::v-deep .el-pagination {
  .btn-prev {
    border-radius: 6px;
  }
  .btn-next {
    border-radius: 6px;
  }
  .el-pager {
    .number {
      border-radius: 6px;
    }
  }
}
// tabs样式
::v-deep .el-tabs__item {
  color: #4f5d78;
  font-size: 12px;
  padding: 0 35px;
}
::v-deep .el-tabs__item.is-active {
  font-weight: 500;
  font-size: 12px;
  color: #066eb7;
}
::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #f5f7fa;
}
// 表格样式
::v-deep .el-table {
  border-bottom: none !important;
}
// 滚动条样式（宽度）
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}
// 滚动条（滑块）
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  width: 14px;
  height: 14px;
}
// 滚动条样式（宽度）
.remark::-webkit-scrollbar {
  width: 4px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}
// 滚动条（滑块）
.remark::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  width: 14px;
  height: 14px;
}
</style>
<style lang="scss">
.el-message {
  min-width: 240px;
}
.el-tooltip__popper.is-light {
  background: #ffffff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ebeef5 !important;
}
.deleteTagMessage {
  padding-bottom: 32px;
  .el-message-box__headerbtn {
    position: absolute;
    top: 32px;
    right: 32px;
  }
  .el-message-box__header {
    padding: 32px 32px 14px;
  }
  .el-message-box__title {
    color: #16181a;
    font-weight: 500;
    font-size: 16px;
  }
  .el-message-box__message {
    font-weight: 400;
    font-size: 14px;
    color: #16181a;
    padding-left: 40px;
  }
  .el-message-box__status.el-icon-warning::before {
    font-size: 16px;
    position: absolute;
    left: 15px;
    top: -8px;
  }
  .el-message-box__btns {
    padding-top: 8px;
    padding-right: 32px;
    display: flex;
    flex-direction: row-reverse;
  }
  .el-button:nth-child(1) {
    background: #066eb7;
    color: #ffffff;
    margin-left: 10px;
  }
  .el-button--primary {
    background: #ffffff !important;
    color: #ff0000 !important;
    border-color: #ff0000 !important;
  }
}
.el-popover.my-popover {
  width: 286px;
  padding: 20px;
  .el-popover__title {
    font-weight: 500;
  }
  .el-icon-close {
    width: 10px;
    height: 10px;
  }
}
.moreTagsPopover {
  position: absolute !important;
  top: 20px !important;
  left: 0 !important;
  max-width: 287px;
  max-height: 237px;
  overflow-y: auto;
  .moreTags {
    display: flex;
    white-space: nowrap;
    flex-wrap: wrap;
    margin: 12px 16px 6px 16px;
    > div {
      margin-bottom: 10px;
    }
  }
}
.moreTagsPopover::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 6px; // 纵向滚动条 必写
}
.moreTagsPopover::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 2px;
}
</style>